import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import upperFirst from 'lodash/upperFirst'
import {
  Box,
  Button,
  IconDelete,
  Inline,
  RadioBar,
  RadioBarItem,
  Text
} from '@machobear/design-system'

import { CustomFeature } from '../../types'

interface CustomItemProps {
  option: CustomFeature
  currentType: string
  showTypeOptions: boolean
  typeOptions: string[]
  onTypeChange: (value: string) => void
  onRemove: () => void
}

const CustomItem = memo(
  ({
    option,
    currentType,
    showTypeOptions,
    typeOptions,
    onTypeChange,
    onRemove
  }: CustomItemProps) => {
    const { t } = useTranslation()

    return (
      <Box
        padding="small"
        borderBottom="borderNeutralLight"
        display="flex"
        flexDirection="column"
        gap="xsmall"
        role="option"
        aria-label={option.name}
      >
        <Box display="flex" justifyContent="spaceBetween" alignItems="center">
          <Text tone="neutral" size="standard">
            {option.name}
          </Text>
          <Inline space="none">
            <Button
              tone="critical"
              size="small"
              icon={<IconDelete />}
              variant="transparent"
              onClick={onRemove}
              aria-label={`Remove ${option.name}`}
            >
              {t('common.remove', 'Remove')}
            </Button>
          </Inline>
        </Box>
        {showTypeOptions && (
          <RadioBar
            id={`${option.name}-type`}
            label=""
            aria-label={`Select ${option.name} type`}
            value={currentType}
            onChange={onTypeChange}
            size="small"
            required
          >
            {typeOptions.map(type => (
              <RadioBarItem key={type} value={type}>
                {t(`b.listing_features.view.${type}.label`, upperFirst(type))}
              </RadioBarItem>
            ))}
          </RadioBar>
        )}
      </Box>
    )
  }
)

export default CustomItem
